/* Remote API client → BODJE IMMO mobile backend.
 *
 * This is the SOURCE OF TRUTH for shared data: listings, auth, favorites,
 * conversations, notifications, saved searches, agent dashboard, boost.
 *
 * JWT token is stored in localStorage under "bodje_token" and sent via
 *   Authorization: Bearer <token>
 *
 * The local site backend (api.js) is kept for site-only features:
 * admin moderation UI, reports, Stripe/Mock Mobile Money, VAPID push.
 */
import axios from "axios";

export const REMOTE_API = "https://bodje-immo-app.emergent.host/api";
export const REMOTE_HOST = "https://bodje-immo-app.emergent.host";
export const REMOTE_TOKEN_KEY = "bodje_token";

export const apiRemote = axios.create({
  baseURL: REMOTE_API,
  withCredentials: false,
  timeout: 20000,
});

apiRemote.interceptors.request.use((config) => {
  const token = localStorage.getItem(REMOTE_TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiRemote.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error.config?.url || "";
    if (status === 401) {
      // Only clear on auth endpoints to avoid spurious logout
      if (url.includes("/auth/me")) {
        localStorage.removeItem(REMOTE_TOKEN_KEY);
      }
      // Swallow 401 so React dev-overlay doesn't surface "Request failed with status 401"
      // for routine anonymous fetches (favorites, conversations, notifications).
      // Callers using validateStatus:()=>true already handle this gracefully.
      return Promise.reject(Object.assign(error, { silent: true }));
    }
    return Promise.reject(error);
  }
);

// Global unhandled-rejection guard: silence API 401s that bubble up anyway.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (ev) => {
    const reason = ev.reason;
    if (reason && (reason.silent || reason?.response?.status === 401)) {
      ev.preventDefault();
    }
  });
}

export function setRemoteToken(token) {
  if (token) localStorage.setItem(REMOTE_TOKEN_KEY, token);
  else localStorage.removeItem(REMOTE_TOKEN_KEY);
}

export function getRemoteToken() {
  return localStorage.getItem(REMOTE_TOKEN_KEY);
}
